module.exports = __webpack_public_path__ + "static/media/cow-in-cycle.6471210c.gif";